import React from 'react';
import { Banner, useT, useIsMobile } from '@repo/common';

/** fullWidth: 관리자 미리보기 — 우측 여백 없이 본문 폭 그대로 */
const BottomBanner = ({ fullWidth = false }) => {
  const t = useT();
  const isMobile = useIsMobile();
  return (
    <div className={`w-full pr-0 ${fullWidth ? '' : 'tabletV:pr-5'}`}>
      <Banner
        size={isMobile ? 's' : 'm'}
        type='warning'
        label={t(
          `This job posting may not be reproduced, redistributed, or modified without the prior consent of Koready,
and may only be used for job-seeking purposes.`,
          '본 채용공고는 Koready의 사전 동의 없이 복제, 재배포, 수정할 수 없으며, 구직 목적으로만 사용할 수 있습니다.',
        )}
        hideClose
      />
    </div>
  );
};

export default BottomBanner;
